<template>
    <div class="encode-decode-container">
        <div class="encode-header">
            <h3 class="section-title">Encode / Decode</h3>
            <div class="encode-tabs">
                <span 
                    v-for="item in menuItems" 
                    :key="item.path"
                    class="tab-item"
                    :class="{ 'is-active': isActive(item.path) }"
                    @click="navigateTo(item.path)">
                    {{ item.label }}
                </span>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
import { useRouter, useRoute } from 'vue-router';

export default {
    name: 'EncodeDecode',
    setup() {
        const router = useRouter();
        const route = useRoute();
        
        const menuItems = [
            { path: '/encode/base64', label: 'Base64' },
            { path: '/encode/md5', label: 'MD5' },
            { path: '/encode/url', label: 'URL' },
            { path: '/encode/html', label: 'HTML' },
        ];

        const isActive = (path) => route.path === path;
        const navigateTo = (path) => router.push(path);

        return { menuItems, isActive, navigateTo };
    }
};
</script>

<style scoped>
.encode-decode-container {
    padding: var(--spacing-lg);
    background: var(--bg-card);
    border-radius: var(--radius-lg);
    border: 1px solid var(--border-light);
}

.encode-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--spacing-lg);
    margin-bottom: var(--spacing-lg);
    padding-bottom: var(--spacing-md);
    border-bottom: 1px solid var(--border-light);
}

.section-title {
    margin: 0;
    font-size: var(--text-lg);
    font-weight: 600;
    color: var(--text-primary);
    white-space: nowrap;
}

.encode-tabs {
    display: flex;
    gap: var(--spacing-xs);
}

.tab-item {
    padding: 6px 12px;
    font-size: var(--text-sm);
    font-weight: 500;
    color: var(--text-secondary);
    border-radius: var(--radius-md);
    cursor: pointer;
    transition: all var(--transition-fast);
}

.tab-item:hover {
    color: var(--color-primary);
    background: var(--bg-hover);
}

.tab-item.is-active {
    color: var(--color-primary);
    background: var(--bg-hover);
}

@media (max-width: 640px) {
    .encode-header {
        flex-direction: column;
        align-items: flex-start;
    }
}
</style>
